import {
    GENERAR_PDF,
    GENERAR_PDF_EXITO,
    GENERAR_PDF_ERROR

} from '../types';
import clienteAxios from '../config/axios';

// Mando al store los datos de residencia
export function generarPDFScreeningAction(informacion) {
    return async (dispatch) => {
        dispatch( generarPDFScreening() );
        try {
            const { config, payload } = informacion;

            const respuesta = await clienteAxios.post(
                '/paciente/generarPDFScreening',
                payload,
                {
                    ...config,
                    responseType: 'blob' // 🔥 CLAVE
                }
            );

            // 🔥 Crear descarga
            const url = window.URL.createObjectURL(new Blob([respuesta.data]));

            const a = document.createElement('a');
            a.href = url;
            a.download = 'screening.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

            dispatch(generarPDFScreeningExito('PDF generado'));

        } catch (error) {
            const errores = error.response;
            if (errores !== undefined) {
                dispatch(generarPDFScreeningError(error.response.data));
            }
        }
    }
}

const generarPDFScreening = () => ({
    type: GENERAR_PDF,
    payload: true
});
const generarPDFScreeningExito = (msg) => ({
    type: GENERAR_PDF_EXITO,
    payload: msg
});
const generarPDFScreeningError = (msg) => ({
    type: GENERAR_PDF_ERROR,
    payload: msg
});